var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon / arrow-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M18.0892 10.5892C18.4147 10.2637 18.4147 9.7361 18.0892 9.41066L14.7559 6.07733C14.4305 5.75189 13.9028 5.75189 13.5774 6.07733C13.252 6.40277 13.252 6.9304 13.5774 7.25584L15.4881 9.16659L2.49999 9.16659C2.03975 9.16659 1.66666 9.53968 1.66666 9.99992C1.66666 10.4602 2.03975 10.8333 2.49999 10.8333L15.4881 10.8333L13.5774 12.744C13.252 13.0694 13.252 13.5971 13.5774 13.9225C13.9028 14.2479 14.4305 14.2479 14.7559 13.9225L18.0892 10.5892Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightIconWhite);
export default __webpack_public_path__ + "static/media/arrow-right-icon-white.9e45fe60f25b670c6089e68a4f1e1399.svg";
export { ForwardRef as ReactComponent };